'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var varint = require('./varint.js');

var digest = require('./hashes/digest.js');

var base58 = require('./bases/base58.js');

var base32 = require('./bases/base32.js');

var bytes = require('./bytes.js');

var CID = /*#__PURE__*/function (_Symbol$toStringTag, _Symbol$for) {
  function CID(version, code, multihash, bytes) {
    _classCallCheck(this, CID);

    this.code = code;
    this.version = version;
    this.multihash = multihash;
    this.bytes = bytes;
    this.byteOffset = bytes.byteOffset;
    this.byteLength = bytes.byteLength;
    this.asCID = this;
    this._baseCache = new Map();
    Object.defineProperties(this, {
      byteOffset: hidden,
      byteLength: hidden,
      code: readonly,
      version: readonly,
      multihash: readonly,
      bytes: readonly,
      _baseCache: hidden,
      asCID: hidden
    });
  }

  _createClass(CID, [{
    key: "toV0",
    value: function toV0() {
      switch (this.version) {
        case 0:
          {
            return this;
          }

        default:
          {
            var code = this.code,
                multihash = this.multihash;

            if (code !== DAG_PB_CODE) {
              throw new Error('Cannot convert a non dag-pb CID to CIDv0');
            }

            if (multihash.code !== SHA_256_CODE) {
              throw new Error('Cannot convert non sha2-256 multihash CID to CIDv0');
            }

            return CID.createV0(multihash);
          }
      }
    }
  }, {
    key: "toV1",
    value: function toV1() {
      switch (this.version) {
        case 0:
          {
            var _this$multihash = this.multihash,
                code = _this$multihash.code,
                digest$1 = _this$multihash.digest;
            var multihash = digest.create(code, digest$1);
            return CID.createV1(this.code, multihash);
          }

        case 1:
          {
            return this;
          }

        default:
          {
            throw Error("Can not convert CID version ".concat(this.version, " to version 0. This is a bug please report"));
          }
      }
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return other && this.code === other.code && this.version === other.version && digest.equals(this.multihash, other.multihash);
    }
  }, {
    key: "toString",
    value: function toString(base) {
      var bytes = this.bytes,
          version = this.version,
          _baseCache = this._baseCache;

      switch (version) {
        case 0:
          return toStringV0(bytes, _baseCache, base || base58.base58btc.encoder);

        default:
          return toStringV1(bytes, _baseCache, base || base32.base32.encoder);
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        code: this.code,
        version: this.version,
        hash: this.multihash.bytes
      };
    }
  }, {
    key: _Symbol$toStringTag,
    get: function get() {
      return 'CID';
    }
  }, {
    key: _Symbol$for,
    value: function value() {
      return 'CID(' + this.toString() + ')';
    }
  }, {
    key: "toBaseEncodedString",
    get: function get() {
      throw new Error('Deprecated, use .toString()');
    }
  }, {
    key: "codec",
    get: function get() {
      throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
  }, {
    key: "buffer",
    get: function get() {
      throw new Error('Deprecated .buffer property, use .bytes to get Uint8Array instead');
    }
  }, {
    key: "multibaseName",
    get: function get() {
      throw new Error('"multibaseName" property is deprecated');
    }
  }, {
    key: "prefix",
    get: function get() {
      throw new Error('"prefix" property is deprecated');
    }
  }], [{
    key: "isCID",
    value: function isCID(value) {
      deprecate(/^0\.0/, IS_CID_DEPRECATION);
      return !!(value && (value[cidSymbol] || value.asCID === value));
    }
  }, {
    key: "asCID",
    value: function asCID(value) {
      if (value instanceof CID) {
        return value;
      } else if (value != null && value.asCID === value) {
        var _version = value.version,
            code = value.code,
            multihash = value.multihash,
            _bytes = value.bytes;
        return new CID(_version, code, multihash, _bytes || encodeCID(_version, code, multihash.bytes));
      } else if (value != null && value[cidSymbol] === true) {
        var _version2 = value.version,
            _multihash = value.multihash,
            _code = value.code;
        var digest$1 = digest.decode(_multihash);
        return CID.create(_version2, _code, digest$1);
      } else {
        return null;
      }
    }
  }, {
    key: "create",
    value: function create(version, code, digest) {
      if (typeof code !== 'number') {
        throw new Error('String codecs are no longer supported');
      }

      switch (version) {
        case 0:
          {
            if (code !== DAG_PB_CODE) {
              throw new Error("Version 0 CID must use dag-pb (code: ".concat(DAG_PB_CODE, ") block encoding"));
            } else {
              return new CID(version, code, digest, digest.bytes);
            }
          }

        case 1:
          {
            var _bytes2 = encodeCID(version, code, digest.bytes);

            return new CID(version, code, digest, _bytes2);
          }

        default:
          {
            throw new Error('Invalid version');
          }
      }
    }
  }, {
    key: "createV0",
    value: function createV0(digest) {
      return CID.create(0, DAG_PB_CODE, digest);
    }
  }, {
    key: "createV1",
    value: function createV1(code, digest) {
      return CID.create(1, code, digest);
    }
  }, {
    key: "decode",
    value: function decode(bytes) {
      var _CID$decodeFirst = CID.decodeFirst(bytes),
          _CID$decodeFirst2 = _slicedToArray(_CID$decodeFirst, 2),
          cid = _CID$decodeFirst2[0],
          remainder = _CID$decodeFirst2[1];

      if (remainder.length) {
        throw new Error('Incorrect length');
      }

      return cid;
    }
  }, {
    key: "decodeFirst",
    value: function decodeFirst(bytes$1) {
      var specs = CID.inspectBytes(bytes$1);
      var prefixSize = specs.size - specs.multihashSize;
      var multihashBytes = bytes.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));

      if (multihashBytes.byteLength !== specs.multihashSize) {
        throw new Error('Incorrect length');
      }

      var digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
      var digest$1 = new digest.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
      var cid = specs.version === 0 ? CID.createV0(digest$1) : CID.createV1(specs.codec, digest$1);
      return [cid, bytes$1.subarray(specs.size)];
    }
  }, {
    key: "inspectBytes",
    value: function inspectBytes(initialBytes) {
      var offset = 0;

      var next = function next() {
        var _varint$decode = varint.decode(initialBytes.subarray(offset)),
            _varint$decode2 = _slicedToArray(_varint$decode, 2),
            i = _varint$decode2[0],
            length = _varint$decode2[1];

        offset += length;
        return i;
      };

      var version = next();
      var codec = DAG_PB_CODE;

      if (version === 18) {
        version = 0;
        offset = 0;
      } else if (version === 1) {
        codec = next();
      }

      if (version !== 0 && version !== 1) {
        throw new RangeError("Invalid CID version ".concat(version));
      }

      var prefixSize = offset;
      var multihashCode = next();
      var digestSize = next();
      var size = offset + digestSize;
      var multihashSize = size - prefixSize;
      return {
        version: version,
        codec: codec,
        multihashCode: multihashCode,
        digestSize: digestSize,
        multihashSize: multihashSize,
        size: size
      };
    }
  }, {
    key: "parse",
    value: function parse(source, base) {
      var _parseCIDtoBytes = parseCIDtoBytes(source, base),
          _parseCIDtoBytes2 = _slicedToArray(_parseCIDtoBytes, 2),
          prefix = _parseCIDtoBytes2[0],
          bytes = _parseCIDtoBytes2[1];

      var cid = CID.decode(bytes);

      cid._baseCache.set(prefix, source);

      return cid;
    }
  }]);

  return CID;
}(Symbol.toStringTag, Symbol["for"]('nodejs.util.inspect.custom'));

var parseCIDtoBytes = function parseCIDtoBytes(source, base) {
  switch (source[0]) {
    case 'Q':
      {
        var decoder = base || base58.base58btc;
        return [base58.base58btc.prefix, decoder.decode("".concat(base58.base58btc.prefix).concat(source))];
      }

    case base58.base58btc.prefix:
      {
        var _decoder = base || base58.base58btc;

        return [base58.base58btc.prefix, _decoder.decode(source)];
      }

    case base32.base32.prefix:
      {
        var _decoder2 = base || base32.base32;

        return [base32.base32.prefix, _decoder2.decode(source)];
      }

    default:
      {
        if (base == null) {
          throw Error('To parse non base32 or base58btc encoded CID multibase decoder must be provided');
        }

        return [source[0], base.decode(source)];
      }
  }
};

var toStringV0 = function toStringV0(bytes, cache, base) {
  var prefix = base.prefix;

  if (prefix !== base58.base58btc.prefix) {
    throw Error("Cannot string encode V0 in ".concat(base.name, " encoding"));
  }

  var cid = cache.get(prefix);

  if (cid == null) {
    var _cid = base.encode(bytes).slice(1);

    cache.set(prefix, _cid);
    return _cid;
  } else {
    return cid;
  }
};

var toStringV1 = function toStringV1(bytes, cache, base) {
  var prefix = base.prefix;
  var cid = cache.get(prefix);

  if (cid == null) {
    var _cid2 = base.encode(bytes);

    cache.set(prefix, _cid2);
    return _cid2;
  } else {
    return cid;
  }
};

var DAG_PB_CODE = 112;
var SHA_256_CODE = 18;

var encodeCID = function encodeCID(version, code, multihash) {
  var codeOffset = varint.encodingLength(version);
  var hashOffset = codeOffset + varint.encodingLength(code);
  var bytes = new Uint8Array(hashOffset + multihash.byteLength);
  varint.encodeTo(version, bytes, 0);
  varint.encodeTo(code, bytes, codeOffset);
  bytes.set(multihash, hashOffset);
  return bytes;
};

var cidSymbol = Symbol["for"]('@ipld/js-cid/CID');
var readonly = {
  writable: false,
  configurable: false,
  enumerable: true
};
var hidden = {
  writable: false,
  enumerable: false,
  configurable: false
};
var version = '0.0.0-dev';

var deprecate = function deprecate(range, message) {
  if (range.test(version)) {
    console.warn(message);
  } else {
    throw new Error(message);
  }
};

var IS_CID_DEPRECATION = "CID.isCID(v) is deprecated and will be removed in the next major release.\nFollowing code pattern:\n\nif (CID.isCID(value)) {\n  doSomethingWithCID(value)\n}\n\nIs replaced with:\n\nconst cid = CID.asCID(value)\nif (cid) {\n  // Make sure to use cid instead of value\n  doSomethingWithCID(cid)\n}\n";
exports.CID = CID;